import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import AccessControl from '@gef-ui/cdu-user/components/AccessControl';
import { getLabelMessage } from '@gef-ui/localization/messages';
import { SidebarSubmenu, SidebarSubmenuItem } from '@gef-ui/material/components/Sidebar';
import Grid from '@gef-ui/material-icons/Grid';

import codelistProvider from 'components/decorators/codelistProvider';
import { codelists } from 'constants/codelists';
import { generateUrl } from 'features/common/fetch/utils';
import { externalLinksIdsInParametersCodelist, externalLinksTypes } from 'features/other/leftMenu/constants';
import { getExternalLinks } from 'features/other/leftMenu/selectors';
import { getUser } from 'features/views/user/selectors';
import { windowOpen } from 'utils';

export const ExternalLinks = ({ parameters }) => {
	const userLogon = useSelector(getUser);
	const externalLinks = useSelector(getExternalLinks);

	const handleOpenExternalLink = useCallback(
		(link) => () => {
			windowOpen(link);
		},
		[],
	);

	const processedExternalLinks = useMemo(
		() =>
			!isEmpty(parameters) &&
			externalLinks.map((item) => {
				const externalLink = parameters.find((p) => p.id === externalLinksIdsInParametersCodelist[item.link]);
				if (externalLink) {
					if (item.link === externalLinksTypes.PK) {
						const correctLink = generateUrl(
							externalLink.shortDescription,
							null,
							{
								representativeFor: userLogon,
							},
							false,
						);
						return {
							...item,
							link: correctLink,
						};
					} else {
						return {
							...item,
							link: externalLink.shortDescription,
						};
					}
				} else {
					return null;
				}
			}),
		[externalLinks, parameters, userLogon],
	);

	return (
		<SidebarSubmenu title={getLabelMessage('leftMenu:aplications')} icon={<Grid />}>
			{processedExternalLinks &&
				processedExternalLinks.map((item, i) => {
					return (
						item && (
							<AccessControl key={i} accessLevel={item.aclItems}>
								<SidebarSubmenuItem
									key={i}
									sx={{
										mb: 1.5,
									}}
									title={getLabelMessage(item.label)}
									onClick={handleOpenExternalLink(item.link)}
									icon={item.icon}
								/>
							</AccessControl>
						)
					);
				})}
		</SidebarSubmenu>
	);
};

ExternalLinks.propTypes = {
	parameters: PropTypes.array,
};

export default codelistProvider(codelists.parameters, 'parameters')(ExternalLinks);
